export default class CurrencyExchangeManager {
    constructor(currencyExchangeClient, $q, ngToast) {
        this.currencyExchangeClient = currencyExchangeClient;
        this.$q = $q;
        this.ngToast = ngToast;
    }

    loadRates(parameters, providers, error_context) {
        var currencyPromises = {};

        angular.forEach(providers, (provider) => {
            parameters.providers = [provider];

            currencyPromises[provider] = this.getConvertedCurrencyFormattedRates(parameters, error_context).then((rates) => {
                return rates[provider];
            });
        });

        var promise = this.$q.all(currencyPromises).then((rates) => {
            return {
                'rates' : rates
            }
        });

        promise.cancel = () => {
            angular.forEach(currencyPromises, (promise) => {
                promise.cancel.resolve('abort');
            });
        };

        return promise;
    }

    getConvertedCurrencyFormattedRates(parameters, error_context) {
        return this.currencyExchangeClient.convertCurrency(parameters, error_context).then(
            (rates) => {
                return this.formatRates(rates, parameters);
            }
        );
    }

    formatRates(rates, parameters) {
        var formatedRates = {};
        angular.forEach(rates, (rate) => {
            if (!formatedRates[rate.provider]) {
                formatedRates[rate.provider] = {};
            }
            formatedRates[rate.provider][angular.isArray(parameters.from_currency) ? rate.from_currency : rate.to_currency] = rate;
        });

        return formatedRates;
    }
}

CurrencyExchangeManager.$inject = ['currencyExchangeClient', '$q', 'ngToast'];
